import React from "react";
import DataTable from "../../components/Table";
import { convertNumberToWords } from "../../utils/utils";

const DepositSlipComponent = ({ data }) => {
  const getTotalAmount = (data = []) => {
    return data.reduce((total, item) => {
      return total + (Number(item.amount) || 0);
    }, 0);
  };

  const depositSlipDate = data[0]?.depositSlipDate ? (data[0]?.depositSlipDate)?.split(" ")[0] : "";
  const depositDate = data[0]?.depositDate ? (data[0]?.depositDate)?.split(" ")[0] : "";
  return (
    <div className="deposit-slip">
      {/* Header */}
      <div className="header">Bharti Axa Life Insurance Co LTD</div>

      {/* Top Grid */}
      <div className="grid section">
        <div className="label">Bank Code :</div>
        <div className="value ">{data[0]?.bankCode}</div>

        <div className="label">Client Code :</div>
        <div className="value ">{data[0]?.clientCode}</div>

        <div className="label">Deposit Slip No :</div>
        <div className="value">{data[0]?.depositSlipNumber}</div>

        <div className="label">Slip Type :</div>
        <div className="value">CHEQUE</div>

        <div className="label">Deposit slip date :</div>
        <div className="value highlight">{depositSlipDate}</div>

        <div className="label">DS Generated by :</div>
        <div className="value">{data[0]?.userIdAcknowledged}</div>

        <div className="label">Deposit Bank Name :</div>
        <div className="value highlight">{data[0]?.depositBankName}</div>
      </div>

      <DataTable
        cellHeaders={[
          "Policy No",
          "Mcustomer Acknowledgement No.",
          "Channel",
          "Payment Type",
          "Amount",
          "Type",
          "Cheque/ DD No.",
          "Cheque Date",
          "Instrument Bank name",
          "Payment Acceptance Date",
          "Accepted by (Branch Name)",
          "User ID acknowledged",
        ]}
        keys={[
          "policyNumber",
          "mcustomerAcknowledgementNo",
          "channel",
          "paymentType",
          "amount",
          "instrumentType",
          "chequeOrDdNumber",
          "chequeDate",
          "instrumentBankName",
          "paymentAcceptanceDate",
          "acceptedByBranchName",
          "userIdAcknowledged",
        ]}
        data={data}
        fileName="Date-Range-Report"
        addSerialNo={true}
        showExcelDownload={false}
        PerPageApiData={false}
        paginationItems={data}
        alwaysShown={false}
      />

      {/* Totals */}
      <div className="grid section">
        <div className="label">Total Amount :</div>
        <div className="value">{getTotalAmount(data)}</div>

        <div className="label">Total Amount in words :</div>
        <div className="value">
          {convertNumberToWords(getTotalAmount(data)) + " only"}
        </div>
      </div>

      {/* Deposit Date */}
      <div className="grid section">
        <div className="label">Deposit Date</div>
        <div className="value highlight">{depositDate}</div>
      </div>

      {/* Signatures */}
      <div className="row-with-seal">
        <div>
          <div className="grid">
            <div className="label">Branch Cashier Name</div>
            <div className="value highlight">{data[0]?.bankCashierName}</div>

            <div className="label">Branch Cashier Signature</div>
            <div className="value danger"></div>

            <div className="label">Branch Stamp</div>
            <div className="value danger"></div>

            <div className="label">Pick Up Person Name</div>
            <div className="value highlight">{data[0]?.pickUpPersonName}</div>

            <div className="label">Pick Up Person Signature</div>
            <div className="value danger"></div>

            <div className="label">Pick Up Vendor Stamp</div>
            <div className="value danger"></div>
          </div>
        </div>

        <div>
          <div className="seal-label">Bank Seal and stamp</div>
          <div className="seal-value"></div>
        </div>
      </div>
    </div>
  );
};

export default DepositSlipComponent;
